import { render, staticRenderFns } from "./knowledgeDetail.vue?vue&type=template&id=20d78fc2&scoped=true&"
import script from "./knowledgeDetail.vue?vue&type=script&lang=js&"
export * from "./knowledgeDetail.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeDetail.vue?vue&type=style&index=0&id=20d78fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d78fc2",
  null
  
)

export default component.exports